module.exports = __webpack_public_path__ + "img/蜂蜜6.c94b437c.png";